import { Reclamation, ReclamPriority, ReclamStatus, CompensationType, SLA_HOURS } from "./reclamations-console";

const pad = (n: number) => String(n).padStart(2, "0");
const toIso = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

// ISO datetime `hours` hours before now (demo data stays realistic whatever the current date).
export const hoursAgo = (hours: number) => toIso(new Date(Date.now() - hours * 3600000));
const stampOf = (iso: string) => `${iso.slice(8, 10)}/${iso.slice(5, 7)} ${iso.slice(11, 16)}`;

type SeedInput = {
  id: string;
  ageHours: number; // created N hours ago
  createdBy: string;
  client: string;
  phone: string;
  reference: string;
  category: string;
  priority: ReclamPriority;
  channel: string;
  status: ReclamStatus;
  assignee?: string;
  subject: string;
  description: string;
  amountClaimed?: number;
  compensation?: [CompensationType, number];
  resolvedAfterHours?: number;
  // Extra events: [hours after creation, text, author]
  events?: [number, string, string][];
};

// Typed entry point so seed literals (tuples, unions) are checked against SeedInput.
export const seedList = (items: SeedInput[]) => items.map(seedReclamation);

export function seedReclamation(s: SeedInput, index: number): Reclamation {
  const createdAt = hoursAgo(s.ageHours);
  const at = (h: number) => hoursAgo(s.ageHours - h);
  const code = `REC-${createdAt.slice(8, 10)}${createdAt.slice(5, 7)}-${String(index + 1).padStart(4, "0")}`;
  return {
    id: s.id,
    code,
    createdAt,
    createdBy: s.createdBy,
    client: s.client,
    phone: s.phone,
    reference: s.reference,
    category: s.category,
    priority: s.priority,
    channel: s.channel,
    status: s.status,
    assignee: s.assignee ?? "",
    subject: s.subject,
    description: s.description,
    amountClaimed: s.amountClaimed ?? 0,
    compensation: { type: s.compensation?.[0] ?? "Aucune", amount: s.compensation?.[1] ?? 0 },
    dueAt: hoursAgo(s.ageHours - SLA_HOURS[s.priority]),
    resolvedAt: s.resolvedAfterHours !== undefined ? at(s.resolvedAfterHours) : undefined,
    history: [[stampOf(createdAt), `Réclamation enregistrée (${s.channel})`, s.createdBy], ...(s.events ?? []).map(([h, text, who]) => [stampOf(at(h)), text, who] as [string, string, string])],
  };
}
